

const initRingStats = () => {

    const onRingStatIntersection = (entries) => {
        for (const entry of entries) {
            if( entry.target.dataset.triggered == false) {
                if (entry.isIntersecting) {
                    let start = 0,
                        ringtarget = entry.target.dataset.ringTarget,
                        numTarget = entry.target.dataset.numTarget,
                        duration = 2500,
                        bar = entry.target.querySelector('.bar')

                        bar.style.strokeDashoffset = (100 - ringtarget) / 100 * Math.PI * bar.getAttribute('r') * 2;

                        const text = entry.target.querySelector('.progress-ring__num > .counter');
                        const step = (timestamp) => {
                            if (!start) start = timestamp;
                            const progress = timestamp - start;
                            const percentage = Math.min(progress / duration, 1);
                            const value = Math.floor(percentage * numTarget);
                            text.innerHTML = value.toLocaleString();
                            if (progress < duration) {
                                window.requestAnimationFrame(step);
                            }
                        };
                        window.requestAnimationFrame(step);

                        entry.target.dataset.triggered = true
                }
            }
        }
    };

    const rings = document.querySelectorAll('.progress-ring')
    if (rings.length) {
        const ringStatObserver = new IntersectionObserver(onRingStatIntersection);
        for (const ring of rings) {
            ringStatObserver.observe(ring);
        }
    }
}
